var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 15.9995V20.9995C22 21.2647 21.8946 21.5191 21.7071 21.7066C21.5196 21.8941 21.2652 21.9995 21 21.9995H3C2.73478 21.9995 2.48043 21.8941 2.29289 21.7066C2.10536 21.5191 2 21.2647 2 20.9995V15.9995H0V20.9995C0 21.7952 0.31607 22.5582 0.87868 23.1208C1.44129 23.6834 2.20435 23.9995 3 23.9995H21C21.7956 23.9995 22.5587 23.6834 23.1213 23.1208C23.6839 22.5582 24 21.7952 24 20.9995V15.9995H22Z",
    fill: "#007afc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.967 -0.000232767C11.5732 -0.00131837 11.1831 0.0753242 10.8189 0.225302C10.4548 0.37528 10.1238 0.595645 9.84503 0.873767L5.92603 4.79277L7.34003 6.20677L10.974 2.57377L11 18.9998H13L12.974 2.58777L16.593 6.20677L18.007 4.79277L14.088 0.873767C13.8094 0.595676 13.4786 0.375322 13.1146 0.225341C12.7507 0.0753607 12.3607 -0.00129599 11.967 -0.000232767Z",
    fill: "#007afc"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#007afc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.1a163a3541990c203fe90d8e19b133f4.svg";
export { ForwardRef as ReactComponent };